import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  status: null,
  message: null,
  data: null,
};

const advisoryAddReducer = createReducer(initialState, {
  ADVISORY_ADD_REQ: (state) => {
    state.loading = true;
    state.user = null;
  },
  ADVISORY_ADD_SUC: (state, actions) => {
    const payload = actions.payload;
    state.loading = false;
    state.status = payload.status;
    state.message = payload.message;
    state.data = payload.data;
  },
  ADVISORY_ADD_ERROR: (state, actions) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = null;
  },
});

export default advisoryAddReducer;
